import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  body {
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 16px;
    line-height: ${theme.typography.lineHeight.normal};
    color: ${theme.colors.text.primary};
    background-color: ${theme.colors.background.default};
    overflow-x: hidden;
    letter-spacing: 0.01em;
  }

  #root {
    min-height: 100vh;
  }

  /* 重置链接样式 */
  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    transition: color ${theme.transitions.fast};

    &:hover {
      color: ${theme.colors.primaryDark};
    }
  }

  /* 重置按钮样式 */
  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    background: none;
    outline: none;
  }

  /* 重置输入框样式 */
  input,
  textarea,
  select {
    font-family: inherit;
    font-size: inherit;
    outline: none;
  }

  :focus-visible {
    outline: 2px solid ${theme.colors.primary};
    outline-offset: 2px;
    box-shadow: 0 0 0 4px ${theme.colors.focusRing};
  }

  button:focus-visible,
  a:focus-visible {
    border-radius: ${theme.borderRadius.md};
  }

  section + section {
    margin-top: ${theme.spacing['2xl']};
  }

  /* 滚动条样式 */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.background.secondary};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.border.dark};
    border-radius: ${theme.borderRadius.full};

    &:hover {
      background: ${theme.colors.text.tertiary};
    }
  }

  /* 响应式图片 */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* 工具类 */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;

